import { Outlet } from "react-router-dom";
import { AuthBootstrap } from "@/components/auth/AuthBootstrap";
import { GoogleAuthProvider } from "@/components/providers/GoogleAuthProvider";
import { ReduxProvider } from "@/components/providers/ReduxProvider";
import { ApiErrorToastBridge } from "@/components/providers/ApiErrorToastBridge";
import { ToastProvider } from "@/components/providers/ToastProvider";
import { HotToaster } from "@/components/providers/HotToaster";
import { GlobalApiLoader } from "@/components/providers/GlobalApiLoader";
import { ThemeProvider } from "@/components/ThemeProvider";
import { BaseDataProvider } from "@/components/providers/BaseDataProvider";
import { HomeownerSubscriptionProvider } from "@/components/providers/HomeownerSubscriptionProvider";
import { PropertyProvider } from "@/components/PropertyProvider";

export default function App() {
  return (
    <ReduxProvider>
      <GoogleAuthProvider>
        <ToastProvider>
          <HotToaster />
          <GlobalApiLoader />
          <ApiErrorToastBridge />
          <AuthBootstrap />
          <BaseDataProvider>
            <HomeownerSubscriptionProvider>
              <ThemeProvider>
                <PropertyProvider>
                  <Outlet />
                </PropertyProvider>
              </ThemeProvider>
            </HomeownerSubscriptionProvider>
          </BaseDataProvider>
        </ToastProvider>
      </GoogleAuthProvider>
    </ReduxProvider>
  );
}
